import $ from "jquery";

import 'slick-carousel';
import 'slick-carousel/slick/slick.css';

import 'simplebar';
import 'simplebar/dist/simplebar.css';

import 'jquery.transit';

// Functions
function expandSidebar() {
	$('.sidebar__inner').transition({ x: '0' });
	$('.sidebar').addClass('is-expanded');
	$(this).addClass("is-pressed");
}

function contractSidebar() {
	$('.sidebar__inner').transition({ x: '-100%' });
	$('.sidebar').removeClass('is-expanded');
	$(this).removeClass("is-pressed");
}

$(document).ready(function(){

	// Toggle sidebar
	$(document).on('click', '.sidebar-toggle', function() {
		if ($('.sidebar').hasClass('is-expanded')) {
			contractSidebar();
			$('body').removeClass("lock-scroll");
		} else {
			expandSidebar();
			$('body').addClass("lock-scroll");
		}
		return false;
	});

	$(document).on('click', '.dimmer', function() {
		contractSidebar();
		return false;
	});

	// Toggle submenu
	$('.page-navigation').on('click', 'a[data-toggle="submenu"]', function() {
		if ($(this).hasClass('is-pressed')) {
			$(this).removeClass("is-pressed");
		} else {
			$(this).addClass("is-pressed");
		}
		if ($(window).width() < 1200) {
			$(this).next().slideToggle(250);
		} else {
			$("#desktop-submenu").slideToggle(250);
		}
		return false;
	});

	// Initialize slider
	$('.slider').slick({
		autoplay: true,
		arrows: false,
		dots: true
	});

	// Open external links in new tab
	$('a').each(function() {
		var a = new RegExp('/' + window.location.host + '/');
		if(!a.test(this.href)) {
			$(this).click(function(event) {
				event.preventDefault();
				event.stopPropagation();
				window.open(this.href, '_blank');
			});
		}
	});

});
